import defineComponent from 'flight';

function SideMenuBgUI() {
    this.defaultAttrs({
        sideMenuBgClass: 'side-menu-bg'
    });

    this._remove = function(evt) {
        if ($(evt.target).hasClass(this.attr.sideMenuBgClass)) {
            this.trigger(document, 'ui:side-menu:on-side-menu-close-click');
        }
    };

    this.after('initialize', function() {
        this.on('click', this._remove);
    });
}

export default defineComponent.component(SideMenuBgUI);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/side-menu-bg-ui.js